import React from 'react'
import { constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import composeDialogModal from 'components/modal/DialogModal/composeDialogModal'

import messages from './messages'


const ErrorPayPalModal = composeDialogModal({
  name: constants.modals.ErrorPayPal,
  title: ({ data }) => (data.title || messages.title),
  buttonTitle: messages.button,
  content: ({ data }) => (
    data.content || <FormattedMessage {...messages.text} />
  ),
})


export default ErrorPayPalModal
